import { cn } from "@/lib/utils";

/**
 * Warm tone-on-tone diagonal stripes — editorial stand-in for non-hero
 * imagery. Replaces the typical grey "image placeholder" block with
 * something that fits the cream palette.
 */
export function StripePlaceholder({
  label = "photo",
  dark = false,
  className,
  style,
}: {
  label?: string;
  dark?: boolean;
  className?: string;
  style?: React.CSSProperties;
}) {
  const c1 = dark ? "oklch(0.32 0.013 70)" : "oklch(0.91 0.014 76)";
  const c2 = dark ? "oklch(0.28 0.012 70)" : "oklch(0.87 0.014 76)";
  const txt = dark ? "oklch(0.75 0.012 70)" : "oklch(0.5 0.012 70)";
  return (
    <div
      role="img"
      aria-label={label}
      className={cn(
        "flex h-full w-full items-end justify-start p-3 font-mono uppercase",
        className,
      )}
      style={{
        backgroundImage: `repeating-linear-gradient(135deg, ${c1} 0 14px, ${c2} 14px 28px)`,
        fontSize: 10,
        letterSpacing: "0.08em",
        color: txt,
        ...style,
      }}
    >
      [&nbsp;{label}&nbsp;]
    </div>
  );
}
